function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1305-398H615V622h-1920z"
}), React.createElement("path", {
  d: "M-1305-167H615v789h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -136)"
}, React.createElement("path", {
  d: "M105.323 148.75c1.09 0 1.988.82 2.11 1.877l.015.248v16.063h7.395a2.125 2.125 0 0 1 1.868 3.138l-.142.226-14.073 19.604a2.125 2.125 0 0 1-3.837-.991l-.014-.248v-16.063H91.25a2.125 2.125 0 0 1-1.868-3.138l.142-.226 14.073-19.604a2.125 2.125 0 0 1 1.726-.886zm9.446 20.422.071-.11h-7.392c-1.09 0-1.988-.82-2.11-1.877l-.015-.247.004-15.94-.005-.125-13.998 19.497-.073.108 7.394.001c1.09 0 1.988.82 2.11 1.877l.015.248-.004 15.94.004.123 14-19.495z",
  fill: "currentColor"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 68,
    height: 68
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/energia.97e06633.svg";
export { SvgComponent as ReactComponent };